import { Add, Delete, Edit } from "@material-ui/icons";
import { CheckSquare, XSquare } from "react-feather";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  deleteFlowApplicationStatus,
  fetchFlowApplicationStatus,
} from "../../../services/flowApplicationStatusService";

import CreateDialog from "./CreateDialog";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../components/Table";
import DeleteDialog from "../../components/CustomDeleteDialog";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import UpdateDialog from "./UpdateDialog";
import dayjs from "dayjs";
import { fetchApplicationStatus } from "../../../services/applicationStatusService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useState } from "react";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({});

const FlowApplicationStatus = () => {
  const { t } = useLocale();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [deleteError, setDeleteError] = useState("");
  const { data, isError, isLoading, refetch } = useQuery(
    "flowApplicationStatus",
    fetchFlowApplicationStatus
  );
  const { data: applStatus } = useQuery(
    "applicationStatus",
    fetchApplicationStatus
  );

  return (
    <>
      <Helmet title={t("Flow Application Status")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Flow Application Status")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Link component={NavLink} exact to="/parameters">
          {t("Parameters")}
        </Link>
        <Typography>{t("Flow Application Status")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <CustomAlert
        open={isError || !!deleteError}
        close={() => {
          refetch();
          setDeleteError("");
        }}
        message={t("A network error occured, please try again later")}
      />

      <CustomTable
        isLoading={isLoading}
        columns={[
          {
            title: t("Id"),
            field: "id",
          },
          {
            title: t("Application Kind"),
            field: "application",
          },
          {
            title: t("From Status"),
            field: "fromStatus",
            render: (rowData) => {
              return (
                applStatus?.find((st) => st?.dscr === rowData?.fromStatus)?.id +
                ". " +
                rowData?.fromStatus
              );
            },
          },
          {
            title: t("To Status"),
            field: "toStatus",
            render: (rowData) => {
              return (
                applStatus?.find((st) => st?.dscr === rowData?.toStatus)?.id +
                ". " +
                rowData?.toStatus
              );
            },
          },

          {
            title: t("Final Step"),
            field: "final_flg",
            render: (rowData) => {
              return rowData?.final_flg === 0 ? <XSquare /> : <CheckSquare />;
            },
          },
          {
            title: t("Rejection"),
            field: "reject_flg",
            render: (rowData) => {
              return rowData?.reject_flg === 0 ? <XSquare /> : <CheckSquare />;
            },
          },
          {
            title: t("Mail"),
            field: "mail_flg",
            render: (rowData) => {
              return rowData?.mail_flg === 0 ? <XSquare /> : <CheckSquare />;
            },
          },
          {
            title: t("Mail Template"),
            field: "email",
          },
          {
            title: t("Effective Date"),
            field: "effective_date",
            render: (rowData) => {
              return rowData?.effective_date
                ? dayjs(rowData?.effective_date).format("DD-MM-YYYY")
                : "";
            },
          },
          {
            title: t("Termination Date"),
            field: "termination_date",
            render: (rowData) => {
              return rowData?.termination_date
                ? dayjs(rowData?.termination_date).format("DD-MM-YYYY")
                : "";
            },
          },
        ]}
        data={data}
        actions={[
          {
            icon: () => <Add />,
            tooltip: t("Add"),
            isFreeAction: true,
            onClick: () => {
              setIsCreateDialogOpen(true);
            },
          },
          {
            icon: () => <Edit htmlColor="#1E90FF" />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);

              setSelectedItem(rowData);
            },
          },
          {
            icon: () => <Delete htmlColor="#B22222" />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
        ]}
      />
      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refetch}
      />
      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
      />
      <DeleteDialog
        title={t("Delete Application Flow / Status")}
        message={t(
          "Are you sure you want to delete the selected Application Flow / Status"
        )}
        fieldName="id"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
        deleteService={deleteFlowApplicationStatus}
      />
    </>
  );
};

export default FlowApplicationStatus;
